import { MEDIA_BREAKPOINTS } from 'constants/application';
import styled from 'styled-components';

export default styled.div`
  height: 100vh;
  .home-page-index-content {
    max-width: ${MEDIA_BREAKPOINTS.MEDIUM};
  }
`;
